function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import TextAtm from "../../../../atoms/TextAtm";
import FlexContainerOrg from "../../../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../../../organisms/FlexItemOrg";
import { pricesTypographies } from "../../priceMol.config";
import PromoText from "./PromoTextElement.styled";
var PromoTextElement = function PromoTextElement(_ref) {
  var text = _ref.text,
    price = _ref.price,
    percent = _ref.percent,
    variant = _ref.variant;
  var typographies = pricesTypographies[variant.type];
  var isAlignRight = variant.align === "right";
  return /*#__PURE__*/React.createElement(FlexContainerOrg, {
    alignItems: "center",
    justifyContent: isAlignRight ? "flex-end" : "space-between",
    gapSpace: 1
  }, /*#__PURE__*/React.createElement(FlexItemOrg, {
    alignSelf: !isAlignRight ? "center" : "flex-start",
    flexGrow: isAlignRight ? undefined : 1,
    flexShrink: isAlignRight ? undefined : 1,
    flexBasis: isAlignRight ? undefined : 0
  }, /*#__PURE__*/React.createElement(PromoText, _extends({
    $isAlignRight: isAlignRight
  }, typographies.promoText), text)), /*#__PURE__*/React.createElement(TextAtm, _extends({}, typographies.promoPrice, {
    htmlTag: "div",
    align: "right"
  }), price, " ", /*#__PURE__*/React.createElement(TextAtm, typographies.promoText, percent)));
};
export default PromoTextElement;